<template>
  <v-snackbar
    class="mt-3 main-snackbar"
    top
    :color="color"
    v-model="showSnackBar"
    :timeout="timeOut"
    auto-height
  >
    <v-icon v-if="icon" color="white" class="mr-2">{{ icon }}</v-icon>
    {{ message }}
    <v-btn flat @click="showSnackBar = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    messageId: {
      type: Number,
    },
    message: {
      type: String,
    },
    color: {
      type: String,
      default: 'success',
    },
    icon: {
      type: String,
      default: 'done',
    },
    timeOut: {
      type: Number,
      default: 3000,
    },
  },
  data: () => ({
    showSnackBar: false,
  }),
  computed: {},
  watch: {
    messageId() {
      if (this.showSnackBar) {
        this.showSnackBar = false
      }
      this.$nextTick(() => {
        this.showSnackBar = true
      })
    },
  },
  methods: {},
}
</script>
